export default {
  fields: [
    {
      type: 'select',
      label: 'Status',
      model: 'status',
      values: () => {
        return [
          { id: 'active', name: 'Active' },
          { id: 'deactivated', name: 'Deactivated' },
          { id: '', name: 'All Statuses' },
        ];
      },
      default: '',
    },
  ],
};
